import { Pencil, Flower2 } from "lucide-react";
import { MaskedLines, FadeUp } from "./Reveal";

const SKETCH_IMG =
  "https://images.unsplash.com/photo-1501618669935-18b6ecb13d6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxza2V0Y2hpbmclMjBub3RlYm9vayUyMGRlc2t8ZW58MHx8fHwxNzg3OTI1OTE0fDA&ixlib=rb-4.1.0&q=85";
const YOGA_IMG = "/assets/avatar-yoga.png";

const SIDES = [
  {
    icon: Pencil,
    img: SKETCH_IMG,
    title: "Drawing & Sketching",
    note: "Stood first in school drawing competition and running competition — from 5th Standard to 10th Standard. The eye for detail never left.",
  },
  {
    icon: Flower2,
    img: YOGA_IMG,
    contain: true,
    title: "Yoga",
    note: "Yoga professional, certified by the Ministry of Ayush, Government of India. Stillness behind the strategy.",
  },
];

export const BeyondBoardroom = () => (
  <section id="about" data-testid="beyond-boardroom" className="relative overflow-hidden bg-white py-24 md:py-36">
    <div className="mx-auto max-w-7xl px-6 md:px-10">
      <p className="text-xs font-bold uppercase tracking-[0.32em] text-[#00BFA5]">The Personal Side</p>
      <h2 className="mt-5 font-display text-4xl font-black tracking-tight text-[#0A192F] md:text-6xl">
        <MaskedLines lines={["Beyond the Boardroom"]} />
      </h2>
      <FadeUp delay={0.15} className="mt-6 max-w-2xl text-base leading-relaxed text-[#4A5568] md:text-lg">
        Not everything fits on a dashboard. Some of the discipline, creativity and calm comes from far older places.
      </FadeUp>

      <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-2">
        {SIDES.map((s, i) => (
          <FadeUp key={s.title} delay={i * 0.15} className="group">
            <div className={`relative overflow-hidden rounded-[2rem] ${s.contain ? "bg-gradient-to-br from-white to-[#E8F5F2]" : ""}`}>
              <img
                src={s.img}
                alt={s.title}
                data-testid={`personal-img-${i}`}
                className={`h-72 w-full transition-transform duration-700 group-hover:scale-105 md:h-80 ${
                  s.contain ? "object-contain" : "object-cover"
                }`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A192F]/70 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 flex items-center gap-3 text-white">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/15 backdrop-blur">
                  <s.icon size={18} />
                </span>
                <span className="font-display text-xl font-black tracking-tight">{s.title}</span>
              </div>
            </div>
            <p className="mt-5 max-w-lg text-sm leading-relaxed text-[#4A5568] md:text-base">{s.note}</p>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
